export const getBaseUrl = () => {
  // URL del backend API - configurable via variable de entorno
  const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://bspaycoapi-qa.payco.net.ve/api/v1';
  
  const isLocalhost = window.location.hostname === 'localhost' || 
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.includes('localhost');

  // En localhost, usar puerto local para desarrollo
  // En producción, usar la URL del API real
  return isLocalhost
    ? (window.location.protocol === 'https:' 
        ? `https://${window.location.hostname}:5003`
        : `http://${window.location.hostname}:5002`)
    : API_BASE_URL;
};
